import _ from "lodash";
import "../../../utils/constants";
import { TaskType } from "../../../utils/constants";
import * as d3 from "d3";
import { black } from "../../../theme/colors";

const deleteButton = (main, node) => {
  const { screen } = node;
  if (screen !== "Execution") {
    var deleteDiv;
    deleteDiv = main
      .insert("xhtml:div")
      .attr("class", "DeleteButton")
      .attr(
        "style",
        "position: absolute; top: -10px; right: -10px; border-radius: 20px; width: 20px; height: 20px; background: rgb(240, 240, 240); color: rgb(221, 34, 34); display: flex; justify-content: center; align-items: center; box-shadow: black 0px 0px 4px;"
      )
      .insert("xhtml:div")
      .attr(
        "style",
        "pointer-events: none; display: flex; height: 100%; align-items: center;"
      );

    const deleteSVG = deleteDiv
      .insert("svg")
      .attr("width", "14")
      .attr("height", "14")
      .attr("viewBox", "0 0 256 256");

    deleteSVG.insert("path").attr("fill", "none").attr("d", "M0 0H256V256H0z");

    deleteSVG
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#DD2222")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "24")
      .attr("d", "M200 56L56 200");

    deleteSVG
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#DD2222")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "24")
      .attr("d", "M200 200L56 56");
  }
};

const addBtnUI = (main, node, bbox) => {
  const { screen } = node;
  if (screen !== "Execution") {
    const height = node?.height;
    const width = node?.width;
    let rectx = "0";
    let recty = "0";
    let gTranslateX = "0";
    let gTranslateY = "0";
    // x=-7 y = 32  translate (-10 25)  terminal ui add btn

    switch (node.type) {
      case "TERMINAL":
        rectx = "-7";
        recty = "32";
        gTranslateX = "-10";
        gTranslateY = "25";
        break;
      case TaskType.Switch:
        rectx = "-7";
        recty = "80";
        gTranslateX = "-9";
        gTranslateY = "75";
        break;
      case TaskType.Default:
      case TaskType.SwitchCase:
      case TaskType.EndOfSwitch:
      case TaskType.EndOfDoWhile:
      case TaskType.ForkBranch:
      case TaskType.EndOfForkJoin:
      case TaskType.Label:
        rectx = "-7";
        recty = "65";
        gTranslateX = "-10";
        gTranslateY = "11";
        break;

      case "INLINE":
      case "JSON_JQ_TRANSFORM":
        rectx = "-7";
        recty = "65";
        gTranslateX = "-10";
        gTranslateY = "65";
        break;

      default:
        rectx = "-7";
        recty = "50";
        gTranslateX = "-9";
        gTranslateY = "45";

        break;
    }

    const maingroup = main
      .insert("g")
      .attr("id", node.id)
      .attr("class", "addbtn");
    maingroup
      .insert("rect")
      .attr("height", "16")
      .attr("width", "16")
      .attr("x", rectx)
      .attr("y", recty)
      .attr("style", "opacity: 0;");

    const rectGroup = maingroup
      .insert("g")
      .attr("transform", `translate(${gTranslateX}, ${gTranslateY})`);

    const foreign = rectGroup
      .insert("svg:foreignObject")
      .attr(
        "style",
        "width: 40px; height: 40px;overflow: visible;cursor: pointer"
      );

    // .attr(
    //   "style",
    //   "width: 20px; overflow: visible; cursor: pointer;position: relative; left: 47%; top: -7%;"
    // )

    const div = foreign
      .insert("xhtml:div")
      .attr(
        "style",
        "cursor: pointer; display: flex; width: 20px; height: 20px; background-color: rgb(255, 255, 255); align-items: center; justify-content: center; border-radius: 20px; box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 10px; white-space: nowrap; overflow: hidden;"
      );

    div
      .insert("xhtml:div")
      .attr("id", "dropping_zone")
      .attr("style", "position: absolute; top: 10px; height: 0px; width: 0px;");

    const svg = div
      .insert("svg:svg")
      .attr("width", "14")
      .attr("height", "14")
      .attr("viewBox", "0 0 256 256");
    svg.insert("path").attr("fill", "none").attr("d", "M0 0H256V256H0z");
    svg
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#000")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16")
      .attr("d", "M40 128L216 128");
    svg
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#000")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16")
      .attr("d", "M128 40L128 216");
  }
};
const subtractBtnUI = (main, node, bbox) => {
  const { screen } = node;
  if (screen !== "Execution") {
    const height = node?.height;
    const width = node?.width;
    let rectx = "0";
    let recty = "0";
    let gTranslateX = "0";
    let gTranslateY = "0";
    // x=-7 y = 32  translate (-10 25)  terminal ui add btn

    switch (node.type) {
      case "TERMINAL":
        rectx = "-7";
        recty = "32";
        gTranslateX = "-10";
        gTranslateY = "25";
        break;
      case TaskType.Switch:
        rectx = "-7";
        recty = "80";
        gTranslateX = "-9";
        gTranslateY = "75";
        break;

      case "INLINE":
      case "JSON_JQ_TRANSFORM":
        rectx = "-7";
        recty = "65";
        gTranslateX = "-10";
        gTranslateY = "65";
        break;

      default:
        rectx = "-7";
        recty = "50";
        gTranslateX = "-9";
        gTranslateY = "45";

        break;
    }

    const maingroup = main
      .insert("g")
      .attr("id", node.id)
      .attr("class", "subtractbtn");
    maingroup
      .insert("rect")
      .attr("height", "16")
      .attr("width", "16")
      .attr("x", rectx)
      .attr("y", recty)
      .attr("style", "opacity: 0;");

    const rectGroup = maingroup
      .insert("g")
      .attr("transform", `translate(${gTranslateX}, ${gTranslateY})`);

    const foreign = rectGroup
      .insert("svg:foreignObject")
      .attr(
        "style",
        "width: 40px; height: 40px;overflow: visible;cursor: pointer"
      );

    // .attr(
    //   "style",
    //   "width: 20px; overflow: visible; cursor: pointer;position: relative; left: 47%; top: -7%;"
    // )

    const div = foreign
      .insert("xhtml:div")
      .attr(
        "style",
        "cursor: pointer; display: flex; width: 20px; height: 20px; background-color: rgb(255, 255, 255); align-items: center; justify-content: center; border-radius: 20px; box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 10px; white-space: nowrap; overflow: hidden;"
      );

    div
      .insert("xhtml:div")
      .attr("id", "dropping_zone")
      .attr("style", "position: absolute; top: 10px; height: 0px; width: 0px;");

    const svg = div
      .insert("svg:svg")
      .attr("width", "14")
      .attr("height", "14")
      .attr("viewBox", "0 0 256 256");
    svg.insert("path").attr("fill", "none").attr("d", "M0 0H256V256H0z");
    svg
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#000")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16")
      .attr("d", "M40 128L216 128");
    svg
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#000")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16")
      .attr("d", "M256 183h 256v 17h 256v 17z");
  }
};
const addAndSubtractUI = (main, node, bbox) => {
  const { screen } = node;
  if (screen !== "Execution") {
    const height = node?.height;
    const width = node?.width;
    let rectx = "0";
    let recty = "0";
    let gTranslateX = "0";
    let gTranslateY = "0";

    switch (node.type) {
      case "TERMINAL":
        rectx = "-7";
        recty = "32";
        gTranslateX = "-10";
        gTranslateY = "25";
        break;
      case TaskType.Switch:
        rectx = "-7";
        recty = "80";
        gTranslateX = "-9";
        gTranslateY = "75";
        break;
      case "INLINE":
      case "JSON_JQ_TRANSFORM":
        rectx = "-7";
        recty = "65";
        gTranslateX = "-10";
        gTranslateY = "65";
        break;
      default:
        rectx = "-7";
        recty = "50";
        gTranslateX = "-9";
        gTranslateY = "45";
        break;
    }

    const maingroup = main.insert("g").attr("id", node.id);
    // .attr("class", "addAndSubtractBtn");

    // Add Button
    const addBtn = maingroup
      .insert("g")
      .attr("class", "addbtn")
      .attr("transform", `translate(${gTranslateX}, ${gTranslateY})`);

    addBtn
      .insert("rect")
      .attr("height", "16")
      .attr("width", "16")
      .attr("x", rectx)
      .attr("y", recty)
      .attr("style", "opacity: 0;");

    const foreignAdd = addBtn
      .insert("svg:foreignObject")
      .attr(
        "style",
        "width: 40px; height: 40px;overflow: visible;cursor: pointer"
      );

    const divAdd = foreignAdd
      .insert("xhtml:div")
      .attr(
        "style",
        "cursor: pointer; display: flex; width: 20px; height: 20px; background-color: rgb(255, 255, 255); align-items: center; justify-content: center; border-radius: 20px; box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 10px; white-space: nowrap; overflow: hidden;"
      );

    const svgAdd = divAdd
      .insert("svg:svg")
      .attr("width", "14")
      .attr("height", "14")
      .attr("viewBox", "0 0 256 256");

    svgAdd.insert("path").attr("fill", "none").attr("d", "M0 0H256V256H0z");
    svgAdd
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#000")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16")
      .attr("d", "M40 128L216 128");
    svgAdd
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#000")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16")
      .attr("d", "M128 40L128 216");

    // Subtract Button
    const subtractBtn = maingroup
      .insert("g")
      .attr("class", "subtractbtn")
      .attr(
        "transform",
        `translate(${parseInt(gTranslateX) + 40}, ${gTranslateY})`
      );

    subtractBtn
      .insert("rect")
      .attr("height", "16")
      .attr("width", "16")
      .attr("x", rectx)
      .attr("y", recty)
      .attr("style", "opacity: 0;");

    const foreignSubtract = subtractBtn
      .insert("svg:foreignObject")
      .attr(
        "style",
        "width: 40px; height: 40px;overflow: visible;cursor: pointer"
      );

    const divSubtract = foreignSubtract
      .insert("xhtml:div")
      .attr(
        "style",
        "cursor: pointer; display: flex; width: 20px; height: 20px; background-color: rgb(255, 255, 255); align-items: center; justify-content: center; border-radius: 20px; box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 10px; white-space: nowrap; overflow: hidden;"
      );

    const svgSubtract = divSubtract
      .insert("svg:svg")
      .attr("width", "14")
      .attr("height", "14")
      .attr("viewBox", "0 0 256 256");

    svgSubtract
      .insert("path")
      .attr("fill", "none")
      .attr("d", "M0 0H256V256H0z");
    svgSubtract
      .insert("path")
      .attr("fill", "none")
      .attr("stroke", "#000")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16")
      .attr("d", "M40 128L216 128");

    const nodeWidth = parseInt(width);
    maingroup.attr(
      "transform",
      `translate(${bbox.x + nodeWidth - 20},${
        bbox.y + parseInt(height) / 2 - 10
      })`
    );
  }
};

const codeUi = (main, node) => {
  const expression = _.get(node, "expression");

  const divs = main
    .insert("xhtml:div")
    .attr("style", "position: absolute; top: 5rem; width: 90%;")
    .insert("xhtml:code")
    .attr("component", "code")
    .attr(
      "style",
      "margin: 10px 0px 0px; border-radius: 6px; background: rgb(238, 238, 238); font-family: monospace; font-size: 0.9em; overflow: hidden auto; word-break: break-word; height: 50px; display: block;"
    )
    .attr("class", "language-js");
  divs.html(expression);
};

const strtwfUi = (main, node) => {
  const divs = main
    .insert("xhtml:div")
    .attr("style", "position: absolute; top: 5rem; width: 90%;")
    .insert("xhtml:div")
    .attr("style", "display: flex; align-items: center; width: 100%;");

  const httpSvg = divs
    .insert("svg:svg")
    .attr("width", "1em")
    .attr("height", "1em")
    .attr("fill", "currentColor")
    .attr("viewBox", "0 0 256 256")
    .attr("style", "margin-right: 10px; flex-shrink: 0;");

  httpSvg
    .insert("rect")
    .attr("width", "256")
    .attr("height", "256")
    .attr("fill", "none");

  httpSvg
    .insert("rect")
    .attr("x", "24")
    .attr("y", "100")
    .attr("width", "56")
    .attr("height", "56")
    .attr("rx", "8")
    .attr("fill", "none")
    .attr("stroke", "currentColor")
    .attr("stroke-linecap", "round")
    .attr("stroke-linejoin", "round")
    .attr("stroke-width", "16");

  httpSvg
    .insert("rect")
    .attr("x", "160")
    .attr("y", "40")
    .attr("width", "64")
    .attr("height", "64")
    .attr("rx", "8")
    .attr("fill", "none")
    .attr("stroke", "currentColor")
    .attr("stroke-linecap", "round")
    .attr("stroke-linejoin", "round")
    .attr("stroke-width", "16");

  httpSvg
    .insert("rect")
    .attr("x", "160")
    .attr("y", "152")
    .attr("width", "64")
    .attr("height", "64")
    .attr("rx", "8")
    .attr("fill", "none")
    .attr("stroke", "currentColor")
    .attr("stroke-linecap", "round")
    .attr("stroke-linejoin", "round")
    .attr("stroke-width", "16");

  httpSvg
    .insert("line")
    .attr("x1", "80")
    .attr("y1", "128")
    .attr("x2", "120")
    .attr("y2", "128")
    .attr("fill", "none")
    .attr("stroke", "currentColor")
    .attr("stroke-linecap", "round")
    .attr("stroke-linejoin", "round")
    .attr("stroke-width", "16");

  httpSvg
    .insert("path")
    .attr("d", "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16")
    .attr("fill", "none")
    .attr("stroke", "currentColor")
    .attr("stroke-linecap", "round")
    .attr("stroke-linejoin", "round")
    .attr("stroke-width", "16");

  divs
    .insert("xhtml:div")
    .attr(
      "style",
      "font-size: 0.8em; padding: 4px 8px; color: rgb(24, 24, 24); background: rgb(219, 219, 219); border-radius: 5px; height: fit-content;"
    )
    .html("Workflow");
};
const expandReduceUi = (main, node, isExpanded) => {
  const container = main
    .insert("xhtml:div")
    .attr("style", "position: absolute; top: 5rem; width: 90%;")
    .insert("xhtml:div")
    .attr("style", "display: flex; align-items: center; width: 100%;");

  const buttonSvg = container
    .insert("svg:svg")
    .attr("width", "1em")
    .attr("height", "1em")
    .attr("fill", "currentColor")
    .attr("viewBox", "0 0 256 256")
    .attr("style", "margin-right: 10px; cursor: pointer;");

  // Draw expand/reduce icon
  if (isExpanded) {
    // Reduce icon (minus sign)
    buttonSvg
      .insert("line")
      .attr("x1", "48")
      .attr("y1", "128")
      .attr("x2", "208")
      .attr("y2", "128")
      .attr("fill", "none")
      .attr("stroke", "currentColor")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16");
  } else {
    // Expand icon (plus sign)
    buttonSvg
      .insert("line")
      .attr("x1", "128")
      .attr("y1", "48")
      .attr("x2", "128")
      .attr("y2", "208")
      .attr("fill", "none")
      .attr("stroke", "currentColor")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16");

    buttonSvg
      .insert("line")
      .attr("x1", "48")
      .attr("y1", "128")
      .attr("x2", "208")
      .attr("y2", "128")
      .attr("fill", "none")
      .attr("stroke", "currentColor")
      .attr("stroke-linecap", "round")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", "16");
  }

  container
    .insert("xhtml:div")
    .attr(
      "style",
      "font-size: 0.8em; padding: 4px 8px; color: rgb(24, 24, 24); background: rgb(219, 219, 219); border-radius: 5px; height: fit-content;"
    )
    .html(isExpanded ? "Collapse" : "Expand");

  // Toggle the expand/reduce state on click
  buttonSvg.on("click", () => {
    // Remove current content
    main.selectAll("*").remove();
    // node.expandFunction()
    // Call the function again with the toggled state
    expandReduceUi(main, !isExpanded);
  });
};
const httpMethodUriUi = (main, node) => {
  const method = _.get(node, "method");
  const uri = _.get(node, "uri");

  const divs = main
    // .insert("xhtml:div")
    .insert("xhtml:div")
    .attr("style", "position: absolute; top: 5rem; width: 90%;")
    .insert("xhtml:div")
    .attr("style", "display: flex; align-items: center; width: 100%;");

  const httpSvg = divs
    .insert("xhtml:a")
    .insert("svg")
    .attr("width", "1em")
    .attr("height", "1em")
    .attr("fill", "currentColor")
    .attr("viewBox", "0 0 256 256")
    .attr("style", "margin-right: 10px; margin-top:5px; flex-shrink: 0;");

  httpSvg
    .insert("rect")
    .attr("width", "256")
    .attr("height", "256")
    .attr("fill", "none");

  httpSvg
    .insert("path")
    .attr(
      "d",
      "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0"
    )
    .attr("fill", "none")
    .attr("stroke", "currentColor")
    .attr("stroke-linecap", "round")
    .attr("stroke-linejoin", "round")
    .attr("stroke-width", "16");

  httpSvg
    .insert("path")
    .attr(
      "d",
      "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0"
    )
    .attr("fill", "none")
    .attr("stroke", "currentColor")
    .attr("stroke-linecap", "round")
    .attr("stroke-linejoin", "round")
    .attr("stroke-width", "16");

  divs
    .insert("xhtml:div")
    .attr(
      "style",
      "font-size: 0.8em; padding: 4px 8px; color: rgb(24, 24, 24); background: rgb(219, 219, 219); border-radius: 5px; height: fit-content;"
    )
    .html(method || "");

  divs
    // .insert("xhtml:div")
    // .attr(
    //   "style",
    //   "padding: 0px 8px; line-height: 2em; overflow: hidden; text-overflow: ellipsis; word-break: keep-all; white-space: nowrap;"
    // )
    .insert("xhtml:a")
    .attr(
      "style",
      "padding: 0px 8px; line-height: 2em; overflow: hidden; text-overflow: ellipsis; word-break: keep-all; white-space: nowrap;"
    )
    .attr(
      "class",
      "MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways css-6e39ea"
    )
    .attr("href", uri)
    .attr("target", "_blank")
    .attr("rel", "noreferrer")
    .html(uri || "");
};

const eventSinkUi = (main, node) => {
  const sink = node?.sink?.split(":") ?? [];

  const divs = main
    // .insert("xhtml:div")
    .insert("xhtml:div")
    .attr("style", "position: absolute; top: 5rem; width: 90%;")
    .insert("xhtml:div")
    .attr("style", "display: flex; align-items: center; width: 100%;");
  divs
    .insert("xhtml:div")
    .attr(
      "style",
      "font-size: 0.8em; padding: 4px 8px; color: rgb(24, 24, 24); background: rgb(219, 219, 219); border-radius: 5px; height: fit-content;"
    )
    .html(sink.length ? sink[0] : "");
  divs
    .insert("xhtml:div")
    .attr(
      "style",
      "padding: 0px 8px; line-height: 2em; overflow: hidden; text-overflow: ellipsis; word-break: keep-all; white-space: nowrap;"
    )
    .html(sink.length ? sink[1] : "");
};

const terminalUI = (foreignParent, width, height, node) => {
  foreignParent
    .attr(
      "style",
      `overflow: visible; transform: translate(${-width / 2 + 1}px, ${
        -height / 2 - 4
      }px)`
    )
    .insert("xhtml:div")
    .attr("style", `width: inherit; height: inherit; border-radius: 10px;`)
    .insert("xhtml:div")
    .attr(
      "style",
      `width: 100%; height: 100%; position: initial; top: 662px; left: 37px;`
    )
    .insert("xhtml:div")
    .attr(
      "style",
      `display: flex; top: 0px; left: 200px; justify-content: center; opacity: 1; padding: 0px; width: 80px; height: 70px;`
    )
    .attr("class", "terminal_ui")
    .insert("xhtml:div")
    .attr("style", `width: 80px; height: 80px; margin-top: 0px;`)
    .insert("xhtml:div")
    .attr(
      "style",
      `display: flex; width: 80px; height: 80px; border-radius: 80px; color: rgb(15, 15, 15); background: rgb(255, 255, 255); border: 5px solid rgb(114, 164, 180); text-align: center; align-items: center; justify-content: center;pointer-events: none;`
    )
    .html(node.name);
};

const switchUI = (foreignParent, width, height, node) => {
  const switchBgColor = "rgba(0, 0, 0, 0.1)";
  const switchMainSVG = foreignParent
    .attr(
      "style",
      `overflow: visible; transform: translate(${-width / 2 + 1}px, ${
        -height / 2 - 4
      }px)`
    )
    .insert("xhtml:div")
    .attr(
      "style",
      `width: ${width}px; height: ${height}px; border-radius: 10px;`
    )
    .insert("xhtml:div")
    .attr(
      "style",
      `width: 100%; height: 100%; position: initial; top: 842px; left: 172px;`
    )
    .insert("xhtml:div")
    .attr(
      "style",
      `display: flex; top: 0px; left: 200px; justify-content: center; opacity: 1; padding: 0px; width: ${width}px; height: ${
        height - 10
      }px;`
    )
    .insert("xhtml:div")
    .attr("style", `padding-bottom: 10px;`)
    .insert("xhtml:div")
    .attr(
      "style",
      `width: 350px; height: 190px; cursor: pointer; border: 3px solid transparent; background-color: ${switchBgColor}; border-radius: 20px;`
    )
    .attr("class", "switch_main-bord")
    .insert("xhtml:div")
    .attr("style", `width: 100%; height: 100%; position: relative;`)
    .attr("class", "switch_main_svg");

  if (!node.class.includes("disable-node-delete")) {
    deleteButton(switchMainSVG, node);
  }

  // text div
  const textDiv = switchMainSVG
    .insert("xhtml:div")
    .attr(
      "style",
      `display: flex; flex-direction: column; align-items: center; justify-content: center; position: absolute; width: 100%; height: 100%; z-index: 2;`
    )
    .attr("class", "switch_main");

  textDiv
    .append("xhtml:div")
    .attr("class", "switch_main_title")
    .html(node.name);

  // textDiv
  //   .append("xhtml:div")
  //   .attr("style", "color: rgb(170, 170, 170);")
  //   .html(node.id);

  // svg div
  const svgDiv = switchMainSVG
    .append("xhtml:div")
    .attr("style", "position: absolute; width: 100%; height: 100%; z-index: 1;")
    .insert("svg:svg")
    .attr("width", "100%")
    .attr("height", "100%")
    .attr("viewBox", "0 0 278 276")
    .attr("preserveAspectRatio", "none");

  const def = svgDiv.append("defs");
  def
    .append("path")
    .attr("id", "path-tk79k9osx6-1")

    .attr(
      "d",
      "M674.079 313.089l113.137 113.137c4.668 4.588 7.118 9.272 7.35 14.053.231 4.78-2.219 9.525-7.351 14.232L674.077 567.648c-5.185 4.12-9.7 6.34-13.543 6.662-3.843.322-8.756-1.898-14.74-6.662L532.655 454.511c-4.73-6.095-7.14-11.2-7.237-15.313-.09-4.114 2.321-8.437 7.237-12.97L645.793 313.09c5.348-4.67 10.073-7.14 14.173-7.41 4.1-.271 8.804 2.198 14.113 7.409z"
    );

  const svgFilter = def
    .append("filter")
    .attr("id", "filter-tk79k9osx6-2")
    .attr("width", "104.5%")
    .attr("height", "104.5%")
    .attr("x", "-2.2%")
    .attr("y", "-2.2%")
    .attr("filterUnits", "objectBoundingBox");

  svgFilter
    .insert("feOffset")
    .attr("in", "SourceAlpha")
    .attr("result", "shadowOffsetOuter1");

  svgFilter
    .insert("feGaussianBlur")
    .attr("in", "shadowOffsetOuter1")
    .attr("result", "shadowBlurOuter1")
    .attr("stdDeviation", "2");

  svgFilter
    .insert("feColorMatrix")
    .attr("in", "shadowOffsetOuter1")
    .attr("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0");

  const g = svgDiv
    .insert("g")
    .attr("fill", "none")
    .attr("fill-rule", "evenodd")
    .attr("stroke", "none")
    .attr("stroke-width", "1")
    .insert("g")
    .attr("transform", "translate(-521 -302)");

  g.insert("use")
    .attr("fill", "#000")
    .attr("filter", "url(#filter-tk79k9osx6-2)")
    .attr("xlink:href", "#path-tk79k9osx6-1");

  g.insert("use").attr("fill", "#FFF").attr("xlink:href", "#path-tk79k9osx6-1");
};

// const dowhileUI = () => {
//   <foreignObject height="230" width="544" style="overflow: visible;">
//     <div style="width: 544px; height: 230px; border-radius: 10px;">
//       <div style="width: 100%; height: 100%; position: initial; top: 2057px; left: 50px;">
//         <div style="display: flex; top: 0px; left: 200px; justify-content: center; opacity: 1; padding: 0px; width: 544px; height: 220px;">
//           <div style="cursor: pointer; display: flex; width: 100%; padding: 20px; border: 3px solid transparent; border-radius: 10px; text-align: center; align-items: center; justify-content: center; position: relative; background: rgba(0, 50, 100, 0.5); box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 20px;">
//             <div
//               class="DeleteButton"
//               style="position: absolute; top: -10px; right: -10px; border-radius: 20px; width: 20px; height: 20px; background: rgb(240, 240, 240); color: rgb(221, 34, 34); display: flex; justify-content: center; align-items: center; box-shadow: black 0px 0px 4px;"
//             >
//               <div style="pointer-events: none; display: flex; height: 100%; align-items: center;">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="14"
//                   height="14"
//                   viewBox="0 0 256 256"
//                 >
//                   <path fill="none" d="M0 0H256V256H0z"></path>
//                   <path
//                     fill="none"
//                     stroke="#DD2222"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                     stroke-width="24"
//                     d="M200 56L56 200"
//                   ></path>
//                   <path
//                     fill="none"
//                     stroke="#DD2222"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                     stroke-width="24"
//                     d="M200 200L56 56"
//                   ></path>
//                 </svg>
//               </div>
//             </div>
//             <div style="position: absolute; top: 10px; left: 10px; display: flex; align-items: center;">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="24"
//                 height="24"
//                 viewBox="0 0 256 256"
//               >
//                 <path fill="none" d="M0 0H256V256H0z"></path>
//                 <path
//                   fill="none"
//                   stroke="white"
//                   stroke-linecap="round"
//                   stroke-linejoin="round"
//                   stroke-width="12"
//                   d="M176.2 99.7L224.2 99.7 224.2 51.7"
//                 ></path>
//                 <path
//                   fill="none"
//                   stroke="white"
//                   stroke-linecap="round"
//                   stroke-linejoin="round"
//                   stroke-width="12"
//                   d="M65.8 65.8a87.9 87.9 0 01124.4 0l34 33.9"
//                 ></path>
//                 <path
//                   fill="none"
//                   stroke="white"
//                   stroke-linecap="round"
//                   stroke-linejoin="round"
//                   stroke-width="12"
//                   d="M79.8 156.3L31.8 156.3 31.8 204.3"
//                 ></path>
//                 <path
//                   fill="none"
//                   stroke="white"
//                   stroke-linecap="round"
//                   stroke-linejoin="round"
//                   stroke-width="12"
//                   d="M190.2 190.2a87.9 87.9 0 01-124.4 0l-34-33.9"
//                 ></path>
//               </svg>
//               <div style="padding-left: 6px; margin-top: -2px; color: white; text-shadow: black 0px 1px 2px;">
//                 do_while_task
//               </div>
//             </div>
//             <div style="position: absolute; top: 20px; right: 20px; height: fit-content; padding: 4px 8px; font-size: 0.8em; background: rgb(221, 221, 221); color: black; border-radius: 5px; margin-left: 8px;">
//               DO_WHILE
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </foreignObject>;
// };

const triggerApprovalUI = (
  foreignParent,
  triggerApprovalGroup,
  width,
  height,
  node
) => {
  foreignParent.attr(
    "style",
    `overflow: visible;transform: translate(${-width / 2}px, ${
      -height / 2 - 6
      // -height / 2 + 15
    }px);padding: 2px 8px; `
  );

  const main = foreignParent.insert("xhtml:div");
  const nameSpan = main
    .append("xhtml:span")
    .attr("class", "foreignName")
    .attr("title", node.name)
    .html(node.name);

  if (!node.class.includes("disable-node-delete")) {
    deleteButton(main, node);
  }

  main
    .append("xhtml:span")
    .attr("class", "foreignRef")
    .attr("title", node.id)
    .html(node.id);
  main
    .attr("class", "rectMain")
    .append("xhtml:span")
    .attr("class", "foreignTag")
    .html(node.type);
};

const otherUI = (foreignParent, width, height, node) => {
  foreignParent.attr(
    "style",
    `overflow: visible;transform: translate(${-width / 2}px, ${
      -height / 2 - 6
    }px);padding: 2px 6px;`
  );

  const main = foreignParent.insert("xhtml:div");

  const nameSpan = main
    .append("xhtml:span")
    .attr("class", "foreignName")
    .attr("title", node.name)
    .html(node.name);

  if (
    [
      TaskType.Default,
      TaskType.EndOfSwitch,
      TaskType.SwitchCase,
      TaskType.EndOfForkJoin,
      TaskType.ForkBranch,
      TaskType.EndOfDoWhile,
      TaskType.Label,
    ].includes(node.type)
  ) {
    main.attr("class", "rectMain rectMain--" + node.type);
    nameSpan.style("top", "11px");
    nameSpan.style("text-align", "center");
    nameSpan.style("width", "88%");
  } else {
    if (!node.class.includes("disable-node-delete") && node.isSubWF != true) {
      deleteButton(main, node);
    }
    main
      .append("xhtml:span")
      .attr("class", "foreignRef")
      .attr("title", node.id)
      .html(node.id);
    main
      .attr("class", "rectMain")
      .append("xhtml:span")
      .attr("class", "foreignTag")
      .html(
        node.type === "JSON_JQ_TRANSFORM"
          ? "JSON JQ"
          : node.type === "FORK_JOIN_DYNAMIC"
          ? "DYN.FORK"
          : node.type
      );
  }
  // main
  //   .append("xhtml:span")
  //   .attr("class", "foreignTag")
  //   .html(
  //     node.type === "JSON_JQ_TRANSFORM"
  //       ? "JSON JQ"
  //       : node.type === "FORK_JOIN_DYNAMIC"
  //       ? "DYN.FORK"
  //       : node.type
  //   );

  // if (
  //   node.type === "TERMINATE" ||
  //   node.type === "WAIT" ||
  //   node.type === "SET_VARIABLE" ||
  //   node.type === "START_WORKFLOW" ||
  //   node.type === "FORK_JOIN" ||
  //   node.type === "FORK_JOIN_DYNAMIC" ||
  //   node.type === "JOIN" ||
  //   node.type === "DO_WHILE" ||
  //   node.type === "DO_WHILE_END"
  // )
  //   main.attr("class", "back_blue rectMain");

  if (node.class === "bar") main.attr("class", "bar rectMain");

  if (node.type === "EVENT") eventSinkUi(main, node);
  if (node.type === "START_WORKFLOW") strtwfUi(main);
  if (node.type === "SUB_WORKFLOW") expandReduceUi(main, node);
  if (node.type === "HTTP" || node.type === "HTTP_POLL")
    httpMethodUriUi(main, node);
  if (node.type === "INLINE" || node.type === "JSON_JQ_TRANSFORM")
    codeUi(main, node);
};

export const rectUI = (parent, bbox, node) => {
  const width = node?.width ?? 350;
  const group = parent.insert("g", ":first-child");
  const height = [
    TaskType.Default,
    TaskType.EndOfSwitch,
    TaskType.SwitchCase,
    TaskType.ForkBranch,
    TaskType.EndOfForkJoin,
    TaskType.EndOfDoWhile,
    TaskType.Label,
  ].includes(node?.type)
    ? 50
    : node?.height ?? 110;
  parent.selectAll(`g.label`).remove();

  group
    .insert("rect")
    .attr("width", width)
    .attr("height", height)
    .attr("transform", `translate(${-width / 2}, ${-height / 2})`)
    .attr("rx", "2")
    .attr("ry", "2")
    .attr("opacity", "1")
    .attr("style", "stroke: none; fill: none;");
  var triggerApprovalGroup = null;
  if (
    node.type === TaskType.Label &&
    (node.name === "START TRIGGER APPROVAL" ||
      node.name === "START SUB WORKFLOW")
  ) {
    const defs = group.append("defs");
    defs
      .append("filter")
      .attr("id", "boxShadow")
      .attr("x", "-50%")
      .attr("y", "-50%")
      .attr("width", "200%")
      .attr("height", "200%")
      .append("feDropShadow")
      .attr("dx", "0")
      .attr("dy", "0")
      .attr("stdDeviation", "10")
      .attr("flood-color", "black")
      .attr("flood-opacity", "0.2");
    triggerApprovalGroup = group
      .insert("rect")
      .attr("class", "trigger-approval-border")
      .attr("id", `${node.id}-box`)
      .attr("data-task-ref", `${node.id}-box`)
      .attr("x", -width / 2 - 25)
      .attr("y", -height / 2 - 25)
      .attr("width", width + 50)
      .attr("height", height + 50)
      .style("cursor", "pointer")
      .style("box-shadow", "0px 0px 10px 0px rgba(0, 0, 0, 0.2)")
      .attr("stroke", "lightblue")
      .attr("stroke-width", "3px")
      .attr("rx", 10)
      .attr("ry", 10)
      .attr("filter", "url(#boxShadow)")
      .attr("opacity", 0.2)
      .attr("display", "flex")
      .attr("fill", "none");
    // .style("pointer-events", "auto");
  }

  const foreignParent = parent.insert("g").insert("svg:foreignObject");

  if (
    node.name === "START TRIGGER APPROVAL" ||
    node.name === "END TRIGGER APPROVAL"
  ) {
    foreignParent.attr("width", width + 10).attr("height", height + 6);

    if (node.name === "START TRIGGER APPROVAL") {
      foreignParent.attr("y", 15);
    }
  } else {
    foreignParent.attr("width", width).attr("height", height);
  }

  foreignParent.raise();

  switch (node.type) {
    case "TERMINAL":
      terminalUI(foreignParent, width, height, node);
      if (node.id !== "__final" && node.screen !== "Execution")
        addBtnUI(parent, node, bbox);
      break;
    case TaskType.Switch:
      switchUI(foreignParent, width, height, node);
      // addBtnUI(parent, node, bbox);
      // subtractBtnUI(parent, node, bbox);
      addAndSubtractUI(parent, node, bbox);
      break;
    case TaskType.ForkJoin:
      otherUI(foreignParent, width, height, node);
      addAndSubtractUI(parent, node, bbox);
      break;
    case TaskType.TriggerApproval:
      triggerApprovalUI(
        foreignParent,
        triggerApprovalGroup,
        width,
        height,
        node
      );
      break;
    default:
      otherUI(foreignParent, width, height, node);
      if (
        node.type !== "TERMINATE" &&
        node.type !== "FORK_JOIN_DYNAMIC" &&
        node.screen !== "Execution" &&
        node.name !== "START TRIGGER APPROVAL" &&
        node.name !== "START SUB WORKFLOW" &&
        !(
          node.class.includes("forkjoinTask") && node.type === TaskType.JoinTask
        ) &&
        node.isSubWF != true &&
        // node.type !== "SUB_WORKFLOW" &&
        !(
          node.class.includes("triggerApprovalTask") &&
          node.type === TaskType.FetchApproval
        ) &&
        node.type !== TaskType.TriggerApproval &&
        !(
          node.class.includes("triggerApprovalTask") &&
          node.name === "END OF SWITCH"
        )
      ) {
        addBtnUI(parent, node);
      }
  }

  return group;
};
